/**
 * This code is cloned in my-favorites.js but with a different form id. If this code or my-favorites.js change make sure to update the other on as well.
 *
 * David - 2021-04-28
 */
(function (Drupal, $, once) {
  Drupal.behaviors.ssddProgramme = {
    attach: function (context) {
      const $form = $('#views-exposed-form-programme-search-api-page-1');
      const $labels = $('label', context);
      const $optionDropDowns = $('.option-dropdown', context);
      const $activeOptions = $('.programme__filter_active_options', context);

      const $dayFilter = $('select[name="date"]');
      const $eventFilter = $('select[name="event[]"]');
      const $areaFilter = $('select[name="area[]"]');
      const $disciplineFilter = $('select[name="discipline[]"]');
      const $participantFilter = $('select[name="participant"]');
      const $searchFilter = $('input[name="search"]');

      function getFilterValues() {
        const filterValues = {
          day: $dayFilter.val(),
          event: $eventFilter.val(),
          discipline: $disciplineFilter.val(),
          area: $areaFilter.val(),
          participant: $participantFilter.val(),
          search: $searchFilter.val(),
        };

        return filterValues;
      }

      function getFilterLabels($filter) {
        let labels = [];
        const $options = $('option:selected', $filter);

        $.each($options, function (index, option) {
          labels.unshift($(option).text());
        });

        return labels;
      }

      function getAllFilterLabels() {
        return {
          day: getFilterLabels($dayFilter),
          event: getFilterLabels($eventFilter),
          discipline: getFilterLabels($disciplineFilter),
          area: getFilterLabels($areaFilter),
          participant: getFilterLabels($participantFilter),
        };
      }

      function mergeFilterValues(currentVals, newVal) {
        if (Array.isArray(currentVals)) {
          // If a set value is clicked, unset it.
          if (currentVals.includes(newVal)) {
            currentVals.splice(currentVals.indexOf(newVal), 1);
          } else {
            currentVals.unshift(newVal);
          }
          return currentVals;
        }
        return newVal;
      }

      function insertActiveFilterLabels($element, labels) {
        $.each(labels, function (index, label) {
          if (label != 'All') {
            $element.append('<li>' + label + '</li>');
          }
        });
      }

      function updateFilterSummary() {
        let $summary = $('.programme__filter_summary .filtered-by');
        let $values = $('.values', $summary);
        let labels = getAllFilterLabels();
        let values = getFilterValues();
        let showSummary = false;

        $values.html('');

        if ('undefined' != typeof values.day && values.day.length > 0 && values.day != 'All') {
          insertActiveFilterLabels($values, labels.day);
          showSummary = true;
        }

        if ('undefined' != typeof values.event && values.event.length > 0) {
          insertActiveFilterLabels($values, labels.event);
          showSummary = true;
        }

        if ('undefined' != typeof values.discipline && values.discipline.length > 0) {
          insertActiveFilterLabels($values, labels.discipline);
          showSummary = true;
        }

        if ('undefined' != typeof values.area && values.area.length > 0) {
          insertActiveFilterLabels($values, labels.area);
          showSummary = true;
        }

        if ('undefined' != typeof values.participant && values.participant.length > 0 && values.participant != 'All') {
          insertActiveFilterLabels($values, labels.participant);
          showSummary = true;
        }

        if ('undefined' != typeof values.search && values.search.length > 0) {
          insertActiveFilterLabels($values, ['"' + values.search + '"']);
          showSummary = true;
        }

        if (showSummary === true) {
          $summary.css('display', 'flex');
          $('.programme__filter_summary .actions').css('display', 'flex');
        }
      }

      $(once('ssddProgramme', $labels)).on('click', function () {
        const $this = $(this);
        const targetId = '#' + $this.attr('for') + '-dropdown';

        let open = !!($(targetId).hasClass('closed'));

        $optionDropDowns.addClass('closed');
        $labels.addClass('closed');

        if (open) {
          $this.removeClass('closed');
          $(targetId).removeClass('closed');
        }
      });

      if ($optionDropDowns.length > 0) {
        $.each($optionDropDowns, function (index, optionDropDown) {
          const $this = $(optionDropDown);
          $activeOptions.append($this);

          if ($this.attr('id').indexOf('participant') != -1) {
            // Participant select reacts to change instead of click.
            $this.on('change', function (e) {
              e.preventDefault();
              $form.submit();
              updateFilterSummary();
            });
          } else {
            $this.on('click', function (e) {
              e.preventDefault();

              const $this = $(e.target);
              let value = $this.data('value');
              const parentId = $this.parent().attr('id');
              const targetId = '#' + parentId.replace('-dropdown', '');
              let currentValues = $(targetId).val();

              if ('undefined' != typeof value) {
                value = value.toString();
              }

              $(targetId).val(mergeFilterValues(currentValues, value));
              $this.toggleClass('selected');
              $form.submit();
              updateFilterSummary();
            });
          }
        });
      }

      updateFilterSummary();
    }
  };

// eslint-disable-next-line no-undef
}(Drupal, jQuery, once));
